import {Epic, ofType} from "redux-observable";
import {AppActions} from "../actions";
import {AppState} from "../AppState";
import {mergeMap} from "rxjs/operators";
import {EMPTY, of} from "rxjs";
import {SelectCompany} from "../actions/WorkforceClinicAction";
import {getCompanySelection} from "../storage/CompanySelection";
import {USER_LOGGED_IN} from "../actions/WorkforceOneLoginActions";

const WorkforceOneCompanySelectPageReturn:  Epic<AppActions, AppActions, AppState> = (action$, states$) => {
    return action$.pipe(
        ofType(USER_LOGGED_IN),
        mergeMap((action: AppActions) => {
                const companySelection = getCompanySelection();
                if(companySelection.company && companySelection.loginLink){
                    return of(SelectCompany(companySelection.company, companySelection.loginLink));
                }
                return EMPTY;
            }
        )
    );
};
export default WorkforceOneCompanySelectPageReturn;